export var ValueCharacterEncoding;
(function (ValueCharacterEncoding) {
    ValueCharacterEncoding["Utf8"] = "UTF-8";
    ValueCharacterEncoding["Unicode"] = "UNICODE";
    ValueCharacterEncoding["Ansel"] = "ANSEL";
    ValueCharacterEncoding["Ascii"] = "ASCII";
    ValueCharacterEncoding["Ansi"] = "ANSI";
})(ValueCharacterEncoding || (ValueCharacterEncoding = {}));
//# sourceMappingURL=ValueCharacterEncoding.js.map